<template>
  <div class="kv-ve-divider" :class="{ 'is-selected': selected }">
    <div
      class="kv-ve-divider__line"
      :style="{
        width: widthPctStyle,
        margin: widthPctMargin,
        borderTop:
          (Number(block.settings.thickness) || 1) +
          'px solid ' +
          (block.settings.color || '#e5e7eb'),
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "VeDividerBlock",
  props: {
    block: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },
  computed: {
    widthMode() {
      const v = String(this.block?.settings?.widthMode || "").toLowerCase();
      return v === "px" ? "px" : "pct";
    },
    widthPct() {
      const n = Number(this.block?.settings?.widthPct);
      if (!Number.isFinite(n)) return 100;
      return Math.min(100, Math.max(10, Math.round(n)));
    },
    widthPx() {
      const n = Number(this.block?.settings?.widthPx);
      if (!Number.isFinite(n)) return 0;
      return Math.min(600, Math.max(0, Math.round(n)));
    },
    widthPctStyle() {
      if (this.widthMode === "px") {
        return this.widthPx > 0 ? `${this.widthPx}px` : "100%";
      }
      const p = this.widthPct;
      return p >= 100 ? "100%" : `${p}%`;
    },
    widthPctMargin() {
      if (this.widthMode === "px") {
        return this.widthPx > 0 ? "0 auto" : "0";
      }
      const p = this.widthPct;
      return p >= 100 ? "0" : "0 auto";
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-divider__line {
  width: 100%;
}
</style>


